import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'İnceleniyor': '#3b82f6', 'Onarılıyor': '#f59e0b', 'Tamamlandı': '#22c55e' };
const DURUM_RGB: Record<string, string> = { 'Bekliyor': '148,163,184', 'İnceleniyor': '59,130,246', 'Onarılıyor': '245,158,11', 'Tamamlandı': '34,197,94' };

@Component({
  selector: 'durum-guncelleme-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--durum" [style.--accent]="durumRenk()" [style.--accent-rgb]="durumRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:7s;--x:15%;--y:25%"></span><span class="gc-p" style="--d:11s;--x:75%;--y:35%"></span><span class="gc-p gc-p--kucuk" style="--d:5s;--x:40%;--y:70%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">DURUM GÜNCELLEMESİ</div>
        <div class="dg-durum-badge" [style.background]="'rgba(' + durumRgb() + ',.15)'" [style.color]="durumRenk()" [style.border-color]="'rgba(' + durumRgb() + ',.3)'">{{ p()?.durum || 'Bekliyor' }}</div>
        @if (p()?.yapilanIslem) { <div class="dg-islem">{{ p().yapilanIslem }}</div> }
        @if (p()?.aciklama) { <div class="dg-aciklama">{{ p().aciklama }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 50 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #0ea5e9; --accent-rgb: 14,165,233; }
    .dg-durum-badge { display: inline-block; padding: 3px 12px; border-radius: 3px; font-size: 10px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; border: 1px solid; animation: badge-pulse 2s ease-in-out infinite; }
    .dg-islem { font-size: 12px; font-weight: 600; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .dg-aciklama { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class DurumGuncellemeKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  durumRenk = computed(() => DURUM_RENK[this.p()?.durum] || '#94a3b8');
  durumRgb = computed(() => DURUM_RGB[this.p()?.durum] || '148,163,184');
}
